module.exports = __webpack_public_path__ + "img/img18.0bf815a2.svg";